// extracted by mini-css-extract-plugin
export var item = "table-module--item--y9DaD";
export var itemRow = "table-module--itemRow--2h4oj";
export var mobileTable = "table-module--mobileTable--5ldsD";
export var sbShowMain = "table-module--sb-show-main--cIPAi";
export var table = "table-module--table--ZxqJd";